import { __extends } from "tslib";
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';
import DownloadAppModal from './DownloadAppModal';
import MobileBadge from './MobileBadge';
import ModalBackground from './ModalBackground';
import HomescreenModal from './HomescreenModal';
var OpenInMobile = /** @class */ (function (_super) {
    __extends(OpenInMobile, _super);
    function OpenInMobile() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            openInstallAppModal: false,
            openHomeScreenModal: false,
        };
        _this.toggleInstallAppModal = function () {
            _this.setState(function (state) { return ({
                openInstallAppModal: !state.openInstallAppModal,
            }); });
        };
        _this.toggleHomeScreenModal = function () {
            _this.setState(function (state) { return ({
                openHomeScreenModal: !state.openHomeScreenModal,
            }); });
        };
        _this.toggleModals = function () {
            _this.toggleInstallAppModal();
            _this.toggleHomeScreenModal();
        };
        return _this;
    }
    OpenInMobile.prototype.render = function () {
        var _a = this.state, openInstallAppModal = _a.openInstallAppModal, openHomeScreenModal = _a.openHomeScreenModal;
        var onClose = this.props.onClose;
        return (React.createElement(Fragment, null,
            !openInstallAppModal && !openHomeScreenModal && (React.createElement(MobileBadge, { onClick: this.toggleInstallAppModal, onClose: onClose })),
            openInstallAppModal && (React.createElement(ModalBackground, { close: onClose },
                React.createElement(DownloadAppModal, { onClick: this.toggleModals, projectID: this.props.projectID }))),
            openHomeScreenModal && (React.createElement(ModalBackground, { back: this.toggleModals, close: onClose },
                React.createElement(HomescreenModal, null)))));
    };
    return OpenInMobile;
}(Component));
export default OpenInMobile;
OpenInMobile.propTypes = {
    onClose: PropTypes.func.isRequired,
    projectID: PropTypes.string.isRequired,
};
OpenInMobile.defaultProps = {
    onClose: noop,
    onComponentDidMount: noop,
};
